module.exports = __webpack_public_path__ + "images/syuccho_kaitori_lp/stores/2_402616790b2b7a137413df98ad312050.jpg";